import React, { useEffect, useState } from "react";
import GroupOrder from "../../assets/GroupOrder.png";
import calender from "../../assets/calender.png";
import profile from "../../assets/profile.png";
import address from "../../assets/orders/address.png";
import desc from "../../assets/orders/desc.png";
import upload from "../../assets/orders/upload.png";
import statusIcon from "../../assets/orders/status.png";
import chat from "../../assets/orders/chat.png";
import { Link, useNavigate } from "react-router-dom";
import Recommended from "./Recommended";
import { useDispatch, useSelector } from "react-redux";
import { createAgentChat } from "../../redux/createChatAgentSlice";
import { Carousel, Modal } from "antd";
import { useTranslation } from "react-i18next";

const Gettingready = ({
  idOrder,
  idAgent,
  agentName,
  agentLastName,
  AgentImage,
  image,
  date,
  time,
  addresss,
  description,
  statuss,
  images,
  updated_atDate,
  updated_at,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { t, i18n } = useTranslation();
  const { language } = i18n;

  const [isModalView, setIsModalView] = useState(false);

  const showModalView = () => {
    setIsModalView(true);
  };
  const handleOkView = () => {
    setIsModalView(false);
  };
  const handleCancelView = () => {
    setIsModalView(false);
  };

  const [createData, setCreateData] = useState({
    order_id: idOrder,
    agent_id: idAgent,
  });

  const { status, error } = useSelector((state) => state.createChatAgent);

  useEffect(() => {
    if (status === "idle") {
      dispatch(createAgentChat(createData));
    }
  }, [dispatch, status, createData]);

  const handleChatLinkClick = () => {
    navigate(`/chat/${idOrder}`);
    dispatch(createAgentChat(createData));
  };

  return (
    <div>
      <img
        src={image}
        className="w-[120px] bg-[#FCFBFA] p-3 rounded-2xl mx-auto my-5"
      />
      <div className="text-center">
        <p className="text-[#737E91] font-semibold text-xl">
          {t("Order number")} 
          <span className="text-[#283D63] font-semibold">#{idOrder}</span>
        </p>
        <p className="text-[#A6ADB9] mt-2">
          {t("Order created on")} {updated_atDate} <br /> {updated_at}
        </p>
      </div>

      <div className="bg-[#FCFBFA] rounded-2xl my-5 px-7 py-4">
        <div className="lg:flex items-center justify-between">
          <div className="flex items-center">
            {AgentImage == null ? (
              <img src={profile} className={`w-[48px] ${language == "en" ? "mr-3" : "ml-3"}`} />
            ) : (
              <img
                src={AgentImage}
                className={`w-[48px] ${language == "en" ? "mr-3" : "ml-3"} rounded-full`}
                onError={(e) => (e.target.src = profile)}
              />
            )}
            <p className="text-[#525D71] font-medium text-lg">
              {agentName} {agentLastName}{" "}
              {t("is getting ready to be on the way")}
            </p>
          </div>
          <button
            onClick={handleChatLinkClick}
            // to={`/chat/${idOrder}`}
            className="bg-[#FE9B71] text-white rounded-xl py-2 px-5 flex items-center text-white max-lg:mt-3"
          >
            <img
              src={chat}
              className={`w-[28px] ${language == "en" ? "mr-2" : "ml-2"}`}
            />
            <p className="font-medium">
              {t("Chat with")} {agentName}
            </p>
          </button>
        </div>
      </div>

      <div className="px-5">
        <div className="grid grid-cols-2 gap-4 max-xl:grid-cols-1 items-center">
          <div className="flex items-center mt-3 ">
            <img src={calender} className={`w-[28px] ${language == "en" ? "mr-2" : "ml-2"}`} />
            <p className="text-[#283D63] font-medium">
              {date} | {time}
            </p>
          </div>
          <div className="flex items-center mt-3 ">
            <img src={address} className={`w-[28px] ${language == "en" ? "mr-2" : "ml-2"}`} />
            <p className="text-[#283D63] font-medium">{addresss}</p>
          </div>
        </div>

        <div className="flex items-start mt-5 ">
          <img src={desc} className={`w-[28px] ${language == "en" ? "mr-2" : "ml-2"}`} />
          <p className="text-[#283D63] font-medium">{description}</p>
        </div>

        <div className="grid grid-cols-2 gap-4 max-xl:grid-cols-1 items-center">
          <div className="flex items-center mt-5 ">
            <img
              src={upload}
              className={`w-[28px] ${language == "en" ? "mr-2" : "ml-2"}`}
            />
            {images?.length > 0 ? (
              <>
                <button
                  onClick={showModalView}
                  className="text-[#6682B6] underline font-medium"
                >
                  {t("View Uploaded Images")}
                </button>
                <Modal
                  title={t("Uploaded Images")}
                  className="orderModal orderModalPricing w_small_modal"
                  open={isModalView}
                  onOk={handleOkView}
                  onCancel={handleCancelView}
                  footer={null}
                >
                  <Carousel
                    arrows
                    infinite={false}
                    className="custome_carousel_images"
                  >
                    {images?.map((img, index) => (
                      <div key={index}>
                        <img
                          src={`https://service.samoolah.com/${img}`}
                          alt={`Uploaded image ${index + 1}`}
                          className="w-[120px] mx-auto my-5"
                        />
                      </div>
                    ))}
                  </Carousel>
                </Modal>
              </>
            ) : (
              <p className="text-[#283D63] font-medium">
                {t("No Uploaded Images")}
              </p>
            )}
          </div>
          <div className="flex items-center mt-3 ">
            <img src={statusIcon} className={`w-[28px] ${language == "en" ? "mr-2" : "ml-2"}`} />
            <p className="text-[#737E91] font-medium">{t("Status")}</p>
            <p className={`text-[#283D63] font-medium ${language == "en" ? "ml-2" : "mr-2"}`}>{statuss}</p>
          </div>
        </div>
      </div>

      <div className="bg-[#FCFBFA] rounded-2xl my-7 px-7 py-4">
        <div className="lg:flex items-center justify-between">
          <p className="text-[#525D71] font-medium text-lg max-lg:mb-4">
            {t("Check out our store for spare parts?")}
          </p>
          <Link
            to="/store"
            className="bg-[#FE9B71] text-white rounded-full py-2 px-5 font-medium text-white"
          >
            {t("Visit Store")}
          </Link>
        </div>
      </div>

      {/* <Recommended /> */}
    </div>
  );
};

export default Gettingready;
